import T from "../../../../model/system/text_translations/Translator";
import PropTypes from "prop-types";
import BaseComponent from "../../../../../lib/components/BaseComponent";

import ButtonGroup from "../../buttons/ButtonGroup";
import React from "react";
import TableEvents from "./TableEvents";
import shortid from "shortid";
import GF from "../../../../../lib/utils/GF";
import Button from "../../buttons/Button";
import {
  Add, ContentCopy, DeleteForever, Download, Edit, FilterAlt, Cached, Upload, Search
} from "@mui/icons-material";
import Privilege from "../../../../../lib/model/types/Privilege";
import CM from "../../../../model/system/CM";

class TableButtonGroup extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      status: GF.getValue(this.props.status, BaseComponent.STATUS_ENABLED)
    }
    this.tableEvents = new TableEvents();
  }

  onTableRefresh(e) {
    if (this.props.onRefreshListener) {
      this.props.onRefreshListener(e);
    }
    if (this.state.status === BaseComponent.STATUS_ENABLED) {
      this.tableEvents.onRefreshListeners.fire(e);
    }
  }

  onOpenFilter(e) {
    if (this.state.status === BaseComponent.STATUS_ENABLED) {
      this.tableEvents.onFilterListeners.fire(e);
    }
  }

  onOpenSimpleFilter(e) {
    if (this.state.status === BaseComponent.STATUS_ENABLED) {
      this.tableEvents.onSimpleSearchListeners.fire(e);
    }
  }

  onOpenSettings(e) {
    if (this.state.status === BaseComponent.STATUS_ENABLED) {
      this.tableEvents.onSettingsListeners.fire(e);
    }
  }

  onAddRecord(e) {
    if (this.state.status === BaseComponent.STATUS_ENABLED) {
      this.tableEvents.onAddRecordListeners.fire(e);
    }
  }

  onEditRecord(e) {
    if (this.state.status === BaseComponent.STATUS_ENABLED) {
      this.tableEvents.onEditRecordListeners.fire(e);
    }
  }

  onDeleteRecord(e) {
    if (this.state.status === BaseComponent.STATUS_ENABLED) {
      this.tableEvents.onDeleteRecordListeners.fire(e);
    }
  }

  onImport(e) {
    if (this.state.status === BaseComponent.STATUS_ENABLED) {
      this.tableEvents.onImportListeners.fire(e);
    }
  }

  onExport(e) {
    if (this.state.status === BaseComponent.STATUS_ENABLED) {
      this.tableEvents.onExportListeners.fire(e);
    }
  }

  onDuplicateRecords(e) {
    if (this.state.status === BaseComponent.STATUS_ENABLED) {
      this.tableEvents.onDuplicateRecordsListeners.fire(e);
    }
  }

  render() {
    let extendedFilterButton;
    if (this.props.showExtendedFilterButton === undefined || this.props.showExtendedFilterButton === true) {
      extendedFilterButton =
        <Button tooltip={T.label_filter_open_extended()} key={shortid()} uid='FILTER' onClick={(e) => this.onOpenFilter(
          e)}><FilterAlt/></Button>;
    }
    let userContext = CM.get().getUserContext();
    let tableProtection = Privilege.getProtectionFromPrivileges(userContext.privileges, this.props.tableName);
    let allowAdd = Privilege.isPrivilegeAllowed(tableProtection, Privilege.ALLOW_CREATE);
    let allowEdit = Privilege.isPrivilegeAllowed(tableProtection, Privilege.ALLOW_EDIT);
    let allowDelete = Privilege.isPrivilegeAllowed(tableProtection, Privilege.ALLOW_DELETE);
    let allowCopy = Privilege.isPrivilegeAllowed(tableProtection, Privilege.ALLOW_EDIT);
    let allowExport = Privilege.isPrivilegeAllowed(tableProtection, Privilege.ALLOW_EXPORT);
    let allowImport = Privilege.isPrivilegeAllowed(tableProtection, Privilege.ALLOW_IMPORT);

    return <><ButtonGroup variant='contained'>
      <Button tooltip='Aktualisieren' uid='REFRESH' onClick={(e) => this.onTableRefresh(e)}>
        <Cached/>
      </Button>
      {extendedFilterButton}
      <Button tooltip={T.label_filter_open_simple()} uid='SEARCH' onClick={(e) => this.onOpenSimpleFilter(e)}>
        <Search/>
      </Button>
      {this.props.editable && allowAdd &&
        <Button tooltip={T.label_add()} uid='ADD' onClick={(e) => this.onAddRecord(e)}><Add/></Button>}
      {this.props.editable && allowEdit &&
        <Button tooltip={T.label_edit()} uid='EDIT' onClick={(e) => this.onEditRecord(e)}><Edit/></Button>}
      {this.props.editable && allowDelete &&
        <Button tooltip={T.label_delete()} uid='DELETE' onClick={(e) => this.onDeleteRecord(e)}><DeleteForever/></Button>}
      {this.props.editable && allowCopy &&
        <Button tooltip={T.label_copy()} uid='COPY' onClick={(e) => this.onDuplicateRecords(e)}><ContentCopy/></Button>}
      {this.props.editable && allowExport &&
        <Button tooltip={T.label_export()} uid='EXPORT' onClick={(e) => this.onExport(e)}><Download/></Button>}
      {this.props.editable && allowImport &&
        <Button tooltip={T.label_import()} uid='IMPORT' onClick={(e) => this.onImport(e)}><Upload/></Button>}
      {this.props.children}
    </ButtonGroup>
      {/*{this.props.showOMSButton &&*/}
      {/*  <Button onClick={this.props.omsButtonHandler} color='secondary'><Mail/>Versand vorbereiten</Button>}*/}
    </>;
  }
}

TableButtonGroup.propTypes = {
  onClick: PropTypes.func,
  editable: PropTypes.bool,
  showExtendedFilterButton: PropTypes.bool,
  showOMSButton: PropTypes.bool,
  omsButtonHandler: PropTypes.func,
  status: PropTypes.string,
  onRefreshListener: PropTypes.func,
  tableName: PropTypes.string
}

export default TableButtonGroup;